import React, { Component } from 'react';
import { SimpleForm, TextInput, Toolbar, SaveButton, translate } from 'react-admin';
import FieldGroup from '~components/FieldGroup';
import { isRequired } from '~utils/inputValidations';

function SectorToolbar(props) {
  return (
    <Toolbar {...props}>
      <SaveButton />
    </Toolbar>
  );
}

class SectorForm extends Component {
  render() {
    return (
      <SimpleForm {...this.props} toolbar={<SectorToolbar />}>
        {this.props.children}
        <FieldGroup label="fieldGroups.sectorEs">
          <TextInput source="name" validate={isRequired} />
        </FieldGroup>
        <FieldGroup label="fieldGroups.sectorEn">
          <TextInput source="nameEn" />
        </FieldGroup>
        <FieldGroup label="fieldGroups.sectorPt">
          <TextInput source="namePt" />
        </FieldGroup>
      </SimpleForm>
    );
  }
}

export default translate(SectorForm);
